import * as React from "react";
import { Select, MenuItem, FormControl, Box, styled } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useFilterStyles } from "../../styles/filterStyles";

const StyledSelect = styled(Select)({
  backgroundColor: '#FFFFFF99',
  borderRadius: '12px',
  height: '48px',
  fontSize: '14px',
  fontFamily: 'inherit',
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1.5px solid #E5E7EB',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: '1.5px solid #E5E7EB',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '2px solid #3B82F6',
    boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
  },
  '& .MuiSelect-select': {
    padding: '12px 14px',
    paddingRight: '40px',
  },
});

const IconWrapper = styled(Box)({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: '#F3F4F6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    fontSize: '18px',
    color: '#6B7280',
  },
});

interface CostEfficiencyFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const options: { value: string; label: string }[] = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const CostEfficiencyFilter: React.FC<CostEfficiencyFilterProps> = ({ value, onChange }) => {
  const filterStyles = useFilterStyles();
  return (
    <>
      <label className={filterStyles.labelText}>Cost Efficiency</label>
      <FormControl fullWidth>
        <StyledSelect
          value={value}
          onChange={(e) => onChange(e.target.value as string)}
          displayEmpty
          renderValue={(val) => {
            if (!val) return <span style={{ color: '#9CA3AF' }}>Select</span>;
            const found = options.find(o => o.value === val);
            return <span>{found ? found.label : val as string}</span>;
          }}
          IconComponent={() => (
            <Box sx={{ position: 'absolute', right: '8px', pointerEvents: 'none', display: 'flex', alignItems: 'center' }}>
              <IconWrapper>
                <KeyboardArrowDownIcon />
              </IconWrapper>
            </Box>
          )}
        >
          <MenuItem value="" disabled>Select</MenuItem>
          {options.map(opt => (
            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </>
  );
};

export default CostEfficiencyFilter;


